import { CustomEventName, GTMEventKey } from '@/utils/gtm';
import { GTMButton } from '@/components/atoms/GTMButton';
import LinkFactory from '@/utils/links';
import { formatTime } from '@/utils/time';
import classNames from 'classnames';
import Link from 'next/link';

const NEWS_CATEGORIES = {
  TWSTOCK: [826, 827, 828, 829, 862, 867, 906, 907, 908, 910, 911, 914],
  CRYPTO: [873, 875, 876, 895, 909, 913],
  INTERNATIONAL: [830, 831, 832, 833, 912],
  FOREX: [838, 885, 893, 915, 920]
};

enum NewsLiveLabel {
  TWSTOCK = '台股',
  CRYPTO = '區塊鏈',
  INTERNATIONAL = '國際股',
  FOREX = '外匯'
}

const LABEL_COLORS = {
  [NewsLiveLabel.TWSTOCK]: 'bg-[#007aff]',
  [NewsLiveLabel.CRYPTO]: 'bg-[#805cff]',
  [NewsLiveLabel.INTERNATIONAL]: 'bg-[#ff6f0f]',
  [NewsLiveLabel.FOREX]: 'bg-[#14BDFF]'
};

type NewsCategoryKey = keyof typeof NEWS_CATEGORIES;

const findTabCategory = (categoryId: number) => {
  const categories = Object.keys(NEWS_CATEGORIES) as NewsCategoryKey[];
  const category = categories.reduce((res, cat: NewsCategoryKey) => {
    if (NEWS_CATEGORIES[cat]?.includes(categoryId)) return cat;
    return res;
  }, '' as NewsCategoryKey);

  return category
    ? {
        label: NewsLiveLabel[category],
        backgroundColor: LABEL_COLORS[NewsLiveLabel[category]]
      }
    : {};
};

type News = {
  title: string;
  newsId: number;
  categoryId: number;
  publishAt: number;
};

const NewsCarouselItem = ({ news }: { news: News }) => {
  const { title, categoryId, publishAt, newsId } = news;
  const { label, backgroundColor } = findTabCategory(categoryId);
  // console.log(categoryId, findTabCategory(categoryId));
  const href = `${LinkFactory.newsDetailLink}/${newsId}`;
  const gtmEvent = {
    [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_NEWS,
    [GTMEventKey.SECTION]: '%p_新聞',
    [GTMEventKey.CLICK_ITEM]: `${newsId}_${title}`
  };

  return (
    <GTMButton gtmEvent={gtmEvent} style='w-full'>
      <Link
        href={href}
        className='flex h-10 w-full items-center rounded-lg bg-[#e2e8f180] px-[14px] py-2'
        title={title}
      >
        <span
          className={classNames(
            'leading-0 mr-2 text-nowrap rounded-md px-2 py-[2px] text-sm text-white',
            backgroundColor
          )}
        >
          {label}
        </span>
        <time className='flex items-center text-[#848d97] after:mx-2 after:block after:h-4 after:w-[2px] after:bg-[#101a251a] after:content-[""]'>
          {formatTime(publishAt, 'HHMM')}
        </time>
        <p className='line-clamp-1 text-left leading-6 text-black'>{title}</p>
      </Link>
    </GTMButton>
  );
};

export default NewsCarouselItem;
